import { useTranslation } from "react-i18next";

const FOOTER_WA_NUMBER = "59893855338";
const FOOTER_PHONE_DISPLAY = "+598 93 855 338";

export default function SiteFooter() {
  const { t, i18n } = useTranslation();
  const waText = i18n.language === "es" ? t("contact.waTextEs") : t("contact.waTextEn");
  const waHref = `https://wa.me/${FOOTER_WA_NUMBER}?text=${encodeURIComponent(waText)}`;
  const links = [
    { href: "#story", key: "nav.story" },
    { href: "#services-panel", key: "nav.services" },
    { href: "#process", key: "nav.process" },
    { href: "#reviews", key: "reviews.nav" },
    { href: "#faq", key: "nav.faq" },
    { href: "#contact", key: "nav.contact" },
  ];

  return (
    <footer className="site-footer">
      <div className="max-w-[1400px] mx-auto grid gap-10 md:gap-8 grid-cols-1 md:grid-cols-12">
        <div className="md:col-span-5" data-reveal>
          <div className="flex items-center gap-2.5">
            <span
              className="footer-mark w-11 h-11 flex items-center justify-center overflow-hidden shrink-0"
              style={{ background: "#ffffff", borderRadius: "10px" }}
            >
              <img
                src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/4926e2d57954fd8852e13e9574e5a955.jpeg"
                alt="Facundo Yoldi — Enfermería a domicilio"
                title="Facundo Yoldi — Enfermería a domicilio"
                width={44}
                height={44}
                className="w-full h-full object-contain"
              />
            </span>
            <span className="flex flex-col leading-none">
              <span className="text-[15px] font-bold">Facundo Yoldi</span>
              <span className="mono text-[9px] tracking-[.18em] uppercase mt-1" style={{ color: "var(--accent2)" }}>
                {t("footer.tag")}
              </span>
            </span>
          </div>
          <p className="mt-5 text-[14.5px] leading-relaxed max-w-[36ch]" style={{ color: "#a9c1c9" }}>
            {t("footer.desc")}
          </p>
          <div className="flex gap-2 mt-6">
            <a
              href={waHref}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`WhatsApp ${FOOTER_PHONE_DISPLAY}`}
              title={`WhatsApp ${FOOTER_PHONE_DISPLAY}`}
              className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full text-[13px]"
              style={{ background: "rgba(255,255,255,0.08)" }}
            >
              <i className="ri-whatsapp-line text-[15px]" aria-hidden="true" />
              WhatsApp
            </a>
            <a
              href="https://instagram.com/enfermero_ok"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full text-[13px]"
              style={{ background: "rgba(255,255,255,0.08)" }}
            >
              <i className="ri-instagram-line text-[15px]" aria-hidden="true" />
              @enfermero_ok
            </a>
          </div>
        </div>

        <div className="md:col-span-3" data-reveal>
          <h3 className="mono text-[10.5px] tracking-[.16em] uppercase mb-4" style={{ color: "var(--accent2)" }}>
            {t("footer.nav")}
          </h3>
          <ul className="grid gap-2.5 text-[14px]">
            {links.map((l) => (
              <li key={l.href}>
                <a href={l.href}>{t(l.key)}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4" data-reveal>
          <h3 className="mono text-[10.5px] tracking-[.16em] uppercase mb-4" style={{ color: "var(--accent2)" }}>
            {t("footer.contact")}
          </h3>
          <ul className="grid gap-3 text-[14px]">
            <li>
              <a href={`tel:+${FOOTER_WA_NUMBER}`} className="flex items-center gap-2.5">
                <i className="ri-phone-line text-[16px]" aria-hidden="true" />
                {FOOTER_PHONE_DISPLAY}
              </a>
            </li>
            <li className="flex items-center gap-2.5" style={{ color: "#a9c1c9" }}>
              <i className="ri-map-pin-line text-[16px]" aria-hidden="true" />
              Maldonado · Punta del Este, Uruguay
            </li>
            <li className="flex items-center gap-2.5" style={{ color: "#a9c1c9" }}>
              <i className="ri-time-line text-[16px]" aria-hidden="true" />
              {t("footer.hours")}
            </li>
          </ul>
        </div>
      </div>

      <div
        className="max-w-[1400px] mx-auto mt-12 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3"
        style={{ borderTop: "1px solid rgba(255,255,255,0.12)" }}
      >
        <p className="text-[12.5px]" style={{ color: "#8fa9b2" }}>{t("footer.legal")}</p>
        <a href="#overview" className="text-[12.5px] inline-flex items-center gap-1.5">
          {t("footer.backTop")}
          <i className="ri-arrow-up-line text-[14px]" aria-hidden="true" />
        </a>
      </div>
    </footer>
  );
}